export function removeCardNumberSpacing(maskedNumber: string): string {
  return maskedNumber.replace(/[X |*]/g, '');
}
